import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const getAll = async ({
  committeeId,
  date,
}) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Ata`,
      {
        params: {
          ...(committeeId && { committeeId }),
          ...(date && { date }),
        }
      }
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const getById = async (id) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/actions/${id}`,

    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const getGroups = async () => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/groups`,

    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const updateUserGroup = async (user, payload) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.patch(
      `${API_BACKEND_HOST}${languageId}/v1/Members/${user}`,
      payload
    );

    return { data: response.data };
  } catch (e) {
    return { error: true, message: e || 'error' }
  }
}

export const createUser = async (data) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Members`,
      data
    );

    return { data: response.data, error: false };
  } catch (e) {
    return { error: true, message: e.response.data?.errors?.length > 0 ? e.response.data.errors[0] : 'defaultErrorMessage' }
  }
}

export const updateDataBySap = async(id) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Members/${id}/import`,
    );

    return { data: response.data, error: false };
  } catch (e) {
    return { error: true, message: e.response.data?.errors?.length > 0 ? e.response.data.errors[0] : 'defaultErrorMessage' }
  }

};
